<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1 class="mb-4">Survey Responses</h1>

        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="surveys"
        >
          <template v-slot:body="{ items }">
            <transition-group
              name="scroll-y-transition"
              tag="tbody"
              v-if="items.length"
            >
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.slug }}</td>
                <td>{{ formatDateAndTime(item.created_at) }}</td>
                <td>{{ formatDateAndTime(item.updated_at) }}</td>
                <td>
                  <v-btn
                    data-testid="surveys-responses-view-btn"
                    class="surveys-responses-view-btn ml-0"
                    small
                    color="primary"
                    @click="selectSurvey(item.id, item.name)"
                  >
                    View Responses
                  </v-btn>
                </td>
              </tr>
            </transition-group>
            <tr v-else>
              <td colspan="12" style="text-align: center">
                No survey responses found.
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import { formatDateAndTime } from "@/helpers/functions/format-date-time";
import router from "@/router";
import { surveyIndexHeaders } from "@/helpers/surveys/survey-index-data-table-headers";

export default {
  data() {
    return {
      loading: false,
      headers: surveyIndexHeaders
    };
  },

  methods: {
    formatDateAndTime: formatDateAndTime,
    selectSurvey(surveyId, surveyName) {
      router.push({ name: "surveysResponse", params: { surveyId: surveyId } });
      this.$store.commit("setSurveyName", surveyName);
    }
  },

  computed: {
    surveys() {
      return this.$store.state.surveys.surveys;
    }
  },

  created() {
    this.$store.dispatch("getAllSurveys");
  },

  components: {
    ApplicationLayout
  }
};
</script>
